/**
 * 日期格式化过滤器
 * @param {Date|String|Number} value
 * @param {String} format
 * @returns {String}
 */
export function formatDate(value, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!value) return ''
  
  const date = new Date(value)
  if (isNaN(date.getTime())) return ''
  
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds)
}

/**
 * 状态文本过滤器
 * @param {Number} status
 * @returns {String}
 */
export function statusText(status) {
  const statusMap = {
    0: '正常',
    1: '禁用'
  }
  return statusMap[status] || '未知'
}

/**
 * 权限文本过滤器
 * @param {String} permission
 * @returns {String}
 */
export function permissionText(permission) {
  const permissionMap = {
    'SYSTEM_MANAGE': '管理员管理',
    'USER_MANAGE': '用户管理',
    'GROUP_MANAGE': '群组管理'
  }
  return permissionMap[permission] || permission
}

/**
 * 文件大小格式化过滤器
 * @param {Number} size
 * @returns {String}
 */
export function fileSize(size) {
  if (!size) return '0 B'
  
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let index = 0
  
  while (size >= 1024 && index < units.length - 1) {
    size /= 1024
    index++
  }
  
  return `${size.toFixed(1)} ${units[index]}`
}

/**
 * 数字千分位格式化
 * @param {Number} num
 * @returns {String}
 */
export function numberFormat(num) {
  if (!num && num !== 0) return ''
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * 性别文本过滤器
 * @param {Number} gender
 * @returns {String}
 */
export function genderText(gender) {
  const genderMap = {
    0: '保密',
    1: '男',
    2: '女'
  }
  return genderMap[gender] || '保密'
}

/**
 * 群组类型文本过滤器
 * @param {Number} groupType
 * @returns {String}
 */
export function groupTypeText(groupType) {
  const typeMap = {
    0: '普通群',
    1: '企业群'
  }
  return typeMap[groupType] || '普通群'
}

/**
 * 群成员角色文本过滤器
 * @param {String} role
 * @returns {String}
 */
export function memberRoleText(role) {
  const roleMap = {
    'owner': '群主',
    'admin': '管理员',
    'member': '成员'
  }
  return roleMap[role] || '成员'
}
